export default {
      id: "dropdown-arrow-usage",
      viewBox: "0 0 16 8",
      url: "assets/" + "sprite.svg#dropdown-arrow",
      toString: function () {
        return this.url;
      }
    }